import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from 'src/app/_config/config';
import { ChatbotSession } from 'src/app/interfaces/chatbot-session.interfaces';
import { ChatbotMessage } from 'src/app/interfaces/chatbot-message.interfaces';

/**
 * HTTP client para los endpoints REST del chatbot.
 *
 * Endpoints:
 *   GET /gmd/chatbot/sessions                          → lista de sesiones del usuario
 *   GET /gmd/chatbot/sessions/:session_id/messages     → mensajes de una sesión
 *
 * La cabecera `Authorization` es añadida automáticamente por el `AuthInterceptor`
 * con el token JWT del usuario autenticado, en el formato esperado por el backend
 * (`@validate_token` decorator en Flask).
 *
 * Requisitos: 4.2, 4.3, 7.1
 */
@Injectable({
  providedIn: 'root'
})
export class ChatbotApiService {

  /** Ruta base para los endpoints del chatbot (relativa a GLOBAL.url). */
  private readonly chatbotPath = 'chatbot/sessions';

  constructor(private http: HttpClient) {}

  /**
   * Obtiene la lista de sesiones de conversación del usuario autenticado.
   *
   * GET /gmd/chatbot/sessions
   *
   * @returns Observable con el arreglo de sesiones ordenadas por fecha de creación.
   */
  getSessions(): Observable<ChatbotSession[]> {
    const url = `${GLOBAL.url}${this.chatbotPath}`;
    return this.http.get<ChatbotSession[]>(url);
  }

  /**
   * Obtiene el historial completo de mensajes de una sesión específica.
   *
   * GET /gmd/chatbot/sessions/:session_id/messages
   *
   * @param sessionId  Identificador único de la sesión (UUID).
   * @returns Observable con el arreglo de mensajes de la sesión en orden cronológico.
   */
  getSessionMessages(sessionId: string): Observable<ChatbotMessage[]> {
    const url = `${GLOBAL.url}${this.chatbotPath}/${sessionId}/messages`;
    return this.http.get<ChatbotMessage[]>(url);
  }
}
